import React, { createContext, useContext, useState } from "react";
import { VfxSnackbarProps } from "./vfxSnackbarProps";
import { MessageSeverity } from "../../utils/lib/messageSeverity";
import { Snackbar } from "./vfxSnackbar";
import { setSnackbarHandler } from "./snackbar";

interface SnackbarContextType {
  showSnackbar: (
    message: string,
    severity: MessageSeverity,
    autoHideDuration?: number
  ) => void;
}

const SnackbarContext = createContext<SnackbarContextType | undefined>(
  undefined
);

export const SnackbarProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [snackbarProps, setSnackbarProps] = useState<VfxSnackbarProps>({
    open: false,
    message: null,
    severity: MessageSeverity.Error,
    autoHideDuration: 10000,
    handleClose: () => setSnackbarProps((prev) => ({ ...prev, open: false })),
  });

  const showSnackbar = (
    message: string,
    severity: MessageSeverity = MessageSeverity.Success,
    autoHideDuration: number = 10000
  ) => {
    setSnackbarProps({
      open: true,
      message,
      severity,
      autoHideDuration,
      handleClose: () => setSnackbarProps((prev) => ({ ...prev, open: false })),
    });
  };

  React.useEffect(() => {
    setSnackbarHandler(showSnackbar);
  }, []);

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      <Snackbar {...snackbarProps} />
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = () => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error("useSnackbar must be used within a SnackbarProvider");
  }
  return context;
};
